import { takeLatest, all, call, put, takeEvery, takeLeading } from 'redux-saga/effects';
import {
  MY_BALANCE,
  GET_MY_TDS,
  VERIFY_PROMO_CODE,
  GET_ALL_VERIFICATION_STATUS_LIST,
  TRANSFER_FUND,
  GET_TDS_DETAILS,
  GET_PAYTM_TOKEN,
  GET_PAYTM_TOKEN_FOR_SDK,
  UPDATE_PAYTM_SDK_RESPONSE,
  GET_CASHFREE_PAYMENT_URL,
  updateBalance,
  GET_BALANCES,
  WITHDRAW_MONEY,
  WITHDRAW_TO_PAYTM_VIA_PAYTM_GATEWAY,
  GET_GAME_TRANSACTION_HISTORY,
  GET_POKER_TRANSACTION_HISTORY,
  GET_BONUS_WALLET_EARNING_HISTORY,
  GET_PRIMARY_WALLET_EARNING_HISTORY,
  GET_USER_DEPOSIT_HISTORY,
  GET_WITHDRAWAL_HISTORY,
  GET_PAYTM_DEPOSIT_STATUS,
  GET_WINNINGS_ADJUSTMENTS_LIST,
  GET_PROMO_CODE_LIST,
  GET_CASHFREE_TOKEN_SDK,
  UPDATE_CASHFREE_SDK_RESPONSE
} from '../actions/account-actions-types';
import { VERIFY_BANK_DETAILS, VERIFY_PAN } from '../actions/user-actions-types';
// import Connection from '../utilities/Connection';
import httpClient from './http-client';

function* myBalance({ payload: { data = { enableLoader: false }, callback } }) {
  const { enableLoader = false } = data;
  const payload = {
    method: 'GET',
    url: '/users/wallets/balance'
  };

  const { result, error } = yield call(httpClient, payload, enableLoader);

  callback({ result, error });
  if (!error && result) {
    yield put(updateBalance(result));
  }
}

function* getBalances({ payload: { data, callback } }) {
  const { walletType } = data;
  const payload = {
    method: 'GET',
    url: `wallets/${walletType}/balance`
  };

  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getMyTDS({ payload: { data, callback } }) {
  const formData = new FormData();
  formData.append('userid', data.userId);
  const payload = {
    data: formData,
    method: 'POST',
    url: 'api/mytdslist'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* getTDSDetails({ payload: { data, callback } }) {
  const formData = new FormData();
  formData.append('userid', data.userId);
  const payload = {
    data: formData,
    method: 'POST',
    url: 'api/tdspopup'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* verifyPromoCode({ payload: { data, callback } }) {
  const { promoCode, amount } = data;
  const payload = {
    method: 'GET',
    url: `coupons/${promoCode}/deposit?amount=${amount}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getAllVerificationStatusList({ payload: { callback } }) {
  const payload = {
    method: 'GET',
    url: 'verification-status'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* verifyPAN({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'pan',
    type: 'pancard'
  };

  const { result, error } = yield call(httpClient, payload);

  callback({ result, error });
}

function* verifyBankDetails({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'bank-accounts',
    type: 'bank_account'
  };

  const { result, error } = yield call(httpClient, payload);

  callback({ result, error });
}

function* transferFund({ payload: { data, callback } }) {
  const { fromWallet } = data;
  const payload = {
    method: 'POST',
    url: `wallets/${fromWallet}/transfer`
  };
  const { result, error } = yield call(httpClient, payload);

  callback({ result, error });
}

function* withdrawMoney({ payload: { data, callback } }) {
  const payload = {
    data: data,
    method: 'POST',
    url: 'withdrawals/cashfree'
  };

  const { result, error } = yield call(httpClient, payload, true);

  callback({ result, error });
}

function* withdrawToPaytmViaPaytmGateway({ payload: { data, callback } }) {
  const { amount } = data;
  const purpose = 'IGamio Paytm withdrawal';
  const body = {
    amount: amount * 100,
    destination: 'wallet',
    comment: purpose
  };
  const payload = {
    data: body,
    method: 'POST',
    url: 'withdrawals/paytm'
  };
  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* getPaytmToken({ payload: { data, callback } }) {
  const { orderAmount, promoCode } = data;

  let body = {
    amount: orderAmount
  };

  if (promoCode !== '') {
    body = {
      amount: orderAmount,
      coupon: promoCode
    };
  }

  const payload = {
    data: body,
    method: 'POST',
    url: 'deposits/paytm/init'
  };

  const { result, error } = yield call(httpClient, payload);

  callback({ result, error });
}

function* getCashfreePaymentURL({ payload: { data, callback } }) {
  const { orderAmount, promoCode } = data;

  let body = {
    amount: orderAmount
  };

  if (promoCode !== '') {
    body = {
      amount: orderAmount,
      coupon: promoCode
    };
  }

  const payload = {
    data: body,
    method: 'POST',
    url: 'deposits/cashfree/init'
  };

  const { result, error } = yield call(httpClient, payload);

  callback({ result, error });
}

function* getCashfreeTokenSDK({ payload: { data, callback } }) {
  const { orderAmount, promoCode } = data;

  let body = {
    amount: orderAmount
  };

  if (promoCode !== '') {
    body = {
      amount: orderAmount,
      coupon: promoCode
    };
  }

  const payload = {
    data: body,
    method: 'POST',
    url: 'deposits/cashfree/fetch-token'
  };

  const { result, error } = yield call(httpClient, payload);

  callback({ result, error });
}

function* getPaytmTokenForSDK({ payload: { data, callback } }) {
  const { orderAmount, promoCode } = data;

  let body = {
    amount: orderAmount
  };

  if (promoCode !== '') {
    body = {
      amount: orderAmount,
      coupon: promoCode
    };
  }

  const payload = {
    data: body,
    method: 'POST',
    url: 'deposits/paytm/sdk/init'
  };

  const { result, error } = yield call(httpClient, payload, false);

  callback({ result, error });
}

function* updatePaytmSdkResponse({ payload: { data, callback } }) {
  let data2 = { ...data };
  delete data2.errorCode;
  delete data2.errorMessage;
  delete data2.retryAllowed;
  const payload = {
    data: data2,
    method: 'POST',
    url: 'deposits/paytm/sdk/callback'
  };

  const { result, error } = yield call(httpClient, payload);

  callback({ result, error });
}

function* updateCashfreeSdkResponse({ payload: { data, callback } }) {
  const payload = {
    data,
    method: 'POST',
    url: 'deposits/cashfree/sdk/callback'
  };

  const { result, error } = yield call(httpClient, payload);

  callback({ result, error });
}

function* getUserDepositHistory({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `deposits?filter= {"offset": 0,"limit": ${limit},"skip": ${skip}}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getUserGameTransactionsHistory({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `/users/games-history?filter= {"offset": 0,"limit": ${limit},"skip": ${skip}}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getPokerTransactionsHistory({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `/users/games/poker?filter= {"offset": 0,"limit": ${limit},"skip": ${skip}}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getUserWithdrawalHistory({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `withdrawals?filter= {"offset": 0,"limit": ${limit},"skip": ${skip}}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getPaytmDepositStatus({ payload: { data, callback } }) {
  const payload = {
    method: 'GET',
    url: `deposits/paytm/${data.orderId}`
  };
  const { result, error } = yield call(httpClient, payload, true);
  callback({ result, error });
}

function* getBonusWalletEarningHistory({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `wallets/bonus/earning?filter= {"offset": 0,"limit": ${limit},"skip": ${skip}}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getPrimaryWalletEarningHistory({ payload: { data, callback } }) {
  const { skip, limit } = data;
  const payload = {
    method: 'GET',
    url: `wallets/primary/earning?filter= {"offset": 0,"limit": ${limit},"skip": ${skip}}`
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getWinningsAdjustmentList({ payload: { callback } }) {
  // const { skip, limit } = data
  const payload = {
    method: 'GET',
    url: 'wallets/game/winning-adjustments'
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* getPromoCodeList({ payload: { callback } }) {
  // const { skip, limit } = data
  const payload = {
    method: 'GET',
    url: 'coupons/published'
  };
  const { result, error } = yield call(httpClient, payload, false);
  callback({ result, error });
}

function* account() {
  yield all([
    yield takeLatest(MY_BALANCE, myBalance),
    yield takeLatest(GET_MY_TDS, getMyTDS),
    yield takeLatest(GET_TDS_DETAILS, getTDSDetails),
    yield takeLeading(VERIFY_PROMO_CODE, verifyPromoCode),
    yield takeLatest(GET_ALL_VERIFICATION_STATUS_LIST, getAllVerificationStatusList),
    yield takeLeading(VERIFY_PAN, verifyPAN),
    yield takeLeading(VERIFY_BANK_DETAILS, verifyBankDetails),
    yield takeLeading(TRANSFER_FUND, transferFund),
    yield takeLeading(GET_PAYTM_TOKEN, getPaytmToken),
    yield takeLeading(GET_PAYTM_TOKEN_FOR_SDK, getPaytmTokenForSDK),
    yield takeLeading(UPDATE_PAYTM_SDK_RESPONSE, updatePaytmSdkResponse),
    yield takeLatest(GET_CASHFREE_PAYMENT_URL, getCashfreePaymentURL),
    yield takeLatest(GET_CASHFREE_TOKEN_SDK, getCashfreeTokenSDK),
    yield takeLeading(UPDATE_CASHFREE_SDK_RESPONSE, updateCashfreeSdkResponse),
    yield takeEvery(GET_BALANCES, getBalances),
    yield takeLeading(WITHDRAW_MONEY, withdrawMoney),
    yield takeLeading(WITHDRAW_TO_PAYTM_VIA_PAYTM_GATEWAY, withdrawToPaytmViaPaytmGateway),
    yield takeLatest(GET_GAME_TRANSACTION_HISTORY, getUserGameTransactionsHistory),
    yield takeLatest(GET_POKER_TRANSACTION_HISTORY, getPokerTransactionsHistory),
    yield takeLatest(GET_USER_DEPOSIT_HISTORY, getUserDepositHistory),
    yield takeLatest(GET_WITHDRAWAL_HISTORY, getUserWithdrawalHistory),
    yield takeLatest(GET_PAYTM_DEPOSIT_STATUS, getPaytmDepositStatus),
    yield takeLatest(GET_BONUS_WALLET_EARNING_HISTORY, getBonusWalletEarningHistory),
    yield takeLatest(GET_PRIMARY_WALLET_EARNING_HISTORY, getPrimaryWalletEarningHistory),
    yield takeLatest(GET_WINNINGS_ADJUSTMENTS_LIST, getWinningsAdjustmentList),
    yield takeLatest(GET_PROMO_CODE_LIST, getPromoCodeList)
  ]);
}

export default account;
